import { render, staticRenderFns } from "./forgetPassword.vue?vue&type=template&id=7bd73859&scoped=true"
import script from "./forgetPassword.vue?vue&type=script&lang=ts"
export * from "./forgetPassword.vue?vue&type=script&lang=ts"
import style0 from "./forgetPassword.vue?vue&type=style&index=0&id=7bd73859&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd73859",
  null
  
)

export default component.exports